'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messages = require('common/messages');

var _resetPassword = require('./reset-password.html');

var _resetPassword2 = _interopRequireDefault(_resetPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _resetPassword2.default,
  bindings: {
    credentials: '<'
  },
  controller: function () {
    function ResetPasswordComponent($state, ResetPasswordService, ToastService) {
      'ngInject';

      _classCallCheck(this, ResetPasswordComponent);

      Object.assign(this, { $state: $state, ResetPasswordService: ResetPasswordService, ToastService: ToastService });
    }

    _createClass(ResetPasswordComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.resetInvalidPasswordMessage();
      }
    }, {
      key: 'resetInvalidPasswordMessage',
      value: function resetInvalidPasswordMessage() {
        this.invalidNewPassword = false;
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        var _this = this;

        this.invalidNewPassword = false;
        this.ResetPasswordService.changePassword(_extends({}, this.credentials)).then(function () {
          _this.ToastService.showSuccess(_messages.PASSWORD_CHANGED);
          _this.$state.go('login');
        }).catch(function (error) {
          if (error && error.data && error.data.Message) {
            if (error.data.Message === 'Invalid New Password') {
              _this.invalidNewPassword = true;
            }
          } else {
            _this.ToastService.showError(error);
          }
        });
      }
    }]);

    return ResetPasswordComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/auth/reset-password/reset-password.component.js